/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'bell': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<defs/><path pid="0" id="bell" class="cls-1" d="M1639.94 36.222a3.522 3.522 0 0 0 6.12 0h-6.12zm11.06-.889h-16v-2.418l.61-.2a3.012 3.012 0 0 0 2.06-2.857v-2.525a5.33 5.33 0 1 1 10.66 0v2.523a3.012 3.012 0 0 0 2.06 2.857l.61.2v2.418zm-13.3-1.778h10.6a4.79 4.79 0 0 1-1.74-3.7v-2.522a3.56 3.56 0 0 0-7.12 0v2.523a4.79 4.79 0 0 1-1.74 3.7z" transform="translate(-1635 -22)"/>'
  }
})
